import styled from "@emotion/styled";
import { fontBarlowSemiCondensed } from "@product/scmp-sdk";

export const CardSectionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CardSectionWord = styled.div`
  padding-block: 5px 7px;
  padding-inline: 12px;

  color: #ffffff;
  font-weight: 500;
  font-size: 14px;
  font-family: ${fontBarlowSemiCondensed};
  line-height: 17px;
  letter-spacing: 0.1em;
  text-transform: uppercase;

  background: #222222;
`;
